import { colors } from 'design-system';

export function getBarColor(totalParticipation: number): string {
  // error
  if (totalParticipation > 100) {
    return '#B80016';
  }
  // success
  if (totalParticipation === 100) {
    return '#27AE60';
  }
  // default
  return colors.bright_turquoise;
}

export function getBarValue(totalParticipation: number): number {
  // ensures min value is 0 and max value is 100
  return Math.max(0, Math.min(100, totalParticipation));
}

export type PercentageBarDetails = {
  value: number;
  color: string;
};

export function getBarDetails(
  totalParticipation: number,
): PercentageBarDetails {
  return {
    color: getBarColor(totalParticipation),
    value: getBarValue(totalParticipation),
  };
}
